export default "__VITE_ASSET__5Us1IK1G__"